import { render, staticRenderFns } from "./LandingPageCategoryDetail.vue?vue&type=template&id=2d1abba0&scoped=true&"
import script from "./LandingPageCategoryDetail.vue?vue&type=script&lang=js&"
export * from "./LandingPageCategoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageCategoryDetail.vue?vue&type=style&index=0&id=2d1abba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1abba0",
  null
  
)

export default component.exports